var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / RS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666666667,3.33333333 C0.666666667,2.43490389 1.16510518,0.646168698 1.16510518,0.646168698 C1.25801503,0.28929958 1.63398345,0 1.99385198,0 L4.67281469,0 C5.03760906,0 5.40980848,0.285489549 5.50156148,0.641518055 C5.50156148,0.641518055 6,2.41347377 6,3.33333333 C6,4.19329707 5.49812738,6.02596322 5.49812738,6.02596322 C5.40711414,6.37981396 5.14040502,6.89891561 4.88998016,7.16315079 C4.88998016,7.16315079 4.33333333,8 3.33333333,8 C2.33333333,8 1.77668651,7.16315079 1.77668651,7.16315079 C1.53182931,6.88895018 1.25685819,6.37712563 1.16510518,6.016801 C1.16510518,6.016801 0.666666667,4.21472719 0.666666667,3.33333333 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-RS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#17508F",
    mask: "url(#mask-2)",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E1444D",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1668",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.333333, 6.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 0.666666667,
    x2: 0.666666667,
    y2: 7.33333333,
    id: "Line",
    stroke: "#E1444D",
    strokeWidth: 1.33333333,
    fill: "none",
    strokeLinecap: "square",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 0.666666667,
    x2: 0.666666667,
    y2: 7.33333333,
    id: "Line",
    stroke: "#E1444D",
    strokeWidth: 1.33333333,
    fill: "none",
    strokeLinecap: "square",
    mask: "url(#mask-4)",
    transform: "translate(3.333333, 4.000000) scale(-1, 1) translate(-3.333333, -4.000000) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/RS.588fc3fc3135132312c3569afff29b83.svg";
export { ForwardRef as ReactComponent };